import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HelperModalComponent } from '../helper-modal/helper-modal.component';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-helper',
    templateUrl: './helper.component.html',
    styleUrls: ['./helper.component.less'],
    imports: [
        MatIcon,
        TranslateModule,
    ]
})
export class HelperComponent {
  constructor(
    public dialog: MatDialog,
    private router: Router
  ) { }

  openModal() {
    /**
     * O modal de ajuda serve todas as telas e, sem tamanho na config, se dimensiona pelo
     * conteúdo: na tela de OS ele mudava de altura a cada troca de aba, porque a aba "Ficha da
     * OS" tem três blocos figura+texto e as outras têm um.
     *
     * Aqui ele abre com tamanho fixo e com a classe `os-guide-dialog`, que liga no LESS o layout
     * de cabeçalho fixo com scroll só no corpo da aba.
     *
     * Na home ("/") o mesmo modal empilha os guias de todas as telas — lá a altura tem de
     * continuar seguindo o conteúdo, então a config extra não se aplica.
     */
    if (this.router.url === '/serviceorder') {
      this.dialog.open(HelperModalComponent, {
        panelClass: 'os-guide-dialog',
        width: 'min(1100px, 92vw)',
        maxWidth: '92vw',
        height: 'min(86vh, 780px)',
      });
      return;
    }

    this.dialog.open(HelperModalComponent);
  }

}
